import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DetailsPurchaseOrder.css';
import PurchaseOrderEditor from 'components/admin/work-orders/details/purchase-order/PurchaseOrderEditor';
import {
  getDocumentFile,
  getDocumentUrl,
  getEdit,
  getNumber,
} from 'selectors/admin/work-orders/details/purchase-order';
import {
  cancelValues,
  removeDocument,
  saveValuesRequest,
  setDocumentFile,
  setEdit,
  setNumber,
} from 'actions/admin/work-orders/details/purchase-order';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';

class DetailsPurchaseOrder extends Component {
  render() {
    return (
      <div className="details-purchase-order">
        <PurchaseOrderEditor
          documentFile={this.props.documentFile}
          documentUrl={this.props.documentUrl}
          edit={this.props.edit}
          number={this.props.number}
          onCancel={this.handleCancel}
          onDocumentDrop={this.handleDocumentDrop}
          onDocumentRemove={this.handleDocumentRemove}
          onEdit={this.handleEdit}
          onNumberChange={this.handleNumberChange}
          onSave={this.handleSave}
        />
      </div>
    );
  }

  handleCancel = () => {
    this.props.dispatch(cancelValues(this.props.currentWorkOrder));
  };

  handleDocumentDrop = (file) => {
    this.props.dispatch(setDocumentFile(file));
  };

  handleDocumentRemove = () => {
    this.props.dispatch(removeDocument());
  };

  handleEdit = () => {
    this.props.dispatch(setEdit(!this.props.edit));
  };

  handleNumberChange = (value) => {
    this.props.dispatch(setNumber(value));
  };

  handleSave = () => {
    this.props.dispatch(
      saveValuesRequest(
        this.props.currentWorkOrder.id,
        this.props.documentFile,
        this.props.number
      )
    );
  };
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    documentFile: getDocumentFile(state),
    documentUrl: getDocumentUrl(state),
    edit: getEdit(state),
    number: getNumber(state),
  };
})(DetailsPurchaseOrder);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/purchase-order/DetailsPurchaseOrder.js